import gql from 'graphql-tag'
import { EntityFields } from '..'
import { PaymentOrderItemFragment } from './paymentOrderItem'
import { DealFragment } from '@/graphql/fragments/crm'
import { ProcessStatusFragment } from '@/graphql/fragments/settings'
import { PaymentSupportTypeFragment } from '@/graphql/fragments/finance/paymentSupportType'

export const BasePaymentOrderFragment = gql`
  fragment BasePaymentOrder on finance_payment_order{
    ${EntityFields}
    idProcessRecord:id_process_record
  }
`

export const PaymentOrderFragment = gql`
  ${BasePaymentOrderFragment}
  ${PaymentOrderItemFragment}
  ${DealFragment}
  ${ProcessStatusFragment}
  ${PaymentSupportTypeFragment}
  fragment PaymentOrder on finance_payment_order{
    ...BasePaymentOrder
    items{
      ...PaymentOrderItem
    }
    supportType: payment_support_type{
      ...PaymentSupportType
    }
    idExpenseCategory: id_expense_category
    supportDate: support_date
    supportNumber: support_number
    process {
      id
      tableName: table_name
    }
  }
`
